// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1kq25","right":"Footer_right__2LkVl","buttons":"Footer_buttons__L2pWY"};